import { render, staticRenderFns } from "./activeVip.vue?vue&type=template&id=169b1ad0&scoped=true&"
import script from "./activeVip.vue?vue&type=script&lang=js&"
export * from "./activeVip.vue?vue&type=script&lang=js&"
import style0 from "./activeVip.vue?vue&type=style&index=0&id=169b1ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169b1ad0",
  null
  
)

export default component.exports